export default function banner() {
  const content = document.querySelector(".js-banner-content");
  
  if (!content) return;
  
  // Check if content height exceeds 80px
  const checkHeight = () => {
    const contentHeight = content.scrollHeight;
    let readMoreText = document.querySelector(".js-banner-read-more");
    const alreadyHasReadMore = !!readMoreText;
    
    if (contentHeight > 80) {
      // Add necessary classes and initial state
      content.classList.add("js-banner-truncated");
      content.style.maxHeight = "80px";
      content.style.overflow = "hidden";
      content.style.position = "relative";
      content.style.height = "auto";
      
      // Create read more text only if it doesn't exist yet
      if (!alreadyHasReadMore) {
        readMoreText = document.createElement("span");
        readMoreText.className = "js-banner-read-more";
        readMoreText.textContent = "Read more";
        readMoreText.style.cursor = "pointer";
        readMoreText.style.color = "#E5453C";
        readMoreText.setAttribute("aria-expanded", "false");
        
        // Add element to DOM
        content.parentNode.insertBefore(readMoreText, content.nextSibling);
        
        // Toggle functionality
        readMoreText.addEventListener("click", () => {
          const isExpanded = readMoreText.getAttribute("aria-expanded") === "true";
          
          if (isExpanded) {
            // Collapse
            content.style.maxHeight = "80px";
            readMoreText.textContent = "Read more";
            readMoreText.setAttribute("aria-expanded", "false");
          } else {
            // Expand
            content.style.maxHeight = contentHeight + "px";
            content.style.height = "auto";
            readMoreText.textContent = "Read less";
            readMoreText.setAttribute("aria-expanded", "true");
          }
        });
      } else if (readMoreText.getAttribute("aria-expanded") === "false") {
        // If element exists but content is resized, update the contentHeight for future clicks
        readMoreText.addEventListener("click", function expandHandler() {
          if (readMoreText.getAttribute("aria-expanded") === "false") {
            content.style.maxHeight = content.scrollHeight + "px";
          }
          // Remove this handler after first execution to prevent duplicates
          readMoreText.removeEventListener("click", expandHandler);
        }, { once: true });
      }
    } else if (alreadyHasReadMore) {
      // If content is now shorter than threshold, remove the read more button
      readMoreText.remove();
      content.style.maxHeight = "";
      content.style.overflow = "";
      content.style.position = "";
      content.style.height = "";
      content.classList.remove("js-banner-truncated");
    }
  };
  
  // Run on load and resize
  checkHeight();
  window.addEventListener("resize", checkHeight);
}
